import {Component, EventEmitter, Input, Output} from '@angular/core';

import {KeyPoint} from 'shared/models/questions/keypoint';
import {MultiSliderQuestionType} from 'shared/models/questions/multi-slider-question-type';
import {SliderQuestionType} from 'shared/models/questions/slider-question-type';
import {TranslatedText} from 'shared/models/translated-text';

@Component({
  selector: 'type-multi-slider',
  templateUrl: './type-multi-slider.component.html',
  styleUrls: ['./type-multi-slider.component.css'],
})
export class TypeMultiSliderComponent {

  @Input() public language: string;
  @Input() public data: MultiSliderQuestionType;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;
  @Output() public dataChange: EventEmitter<MultiSliderQuestionType>;

  constructor() {
    this.data = new MultiSliderQuestionType();
    this.dataChange = new EventEmitter<MultiSliderQuestionType>();
  }

  public addSlider(): void {
    this.data.addSlider('slider');
    this.data.sliders[this.data.sliders.length - 1].addKeyPoint();
    this.dataChange.emit(this.data);
  }

  public removeSlider(index: number): void {
    this.data.removeSlider(index);
    this.dataChange.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-multi-slider/type-multi-slider.component.ts